import React, { lazy, Suspense } from 'react';
import { Link } from 'react-router-dom';
import { Common } from '../../../common/common';
import { MARK_EXCLAMATION } from '../../../common/images-s3';
//import { COMPANY_MICRO_SITE } from '../../../common';

const ImageLoader = lazy(() => import('../../../common/image-loader'));

class AdoptError extends React.Component {

    constructor(props) {
        super(props)
    
        this.state = {
             error : this.props.adoptErrorMsg ?? ''
        }

        this.backToForm = this.backToForm.bind(this);
    }

    backToForm(){
        this.props.changeView(false)
    }
    

    render() {

        return (
            <div className="c-donation-e-receipt-account-success">
                <div className="c-donation-e-receipt">
                    <div className="c-img">
                        <Suspense fallback={null}>
                            <ImageLoader type="image" src={MARK_EXCLAMATION} alt=""></ImageLoader>
                        </Suspense>
                    </div>
                    <h3>Adoption Unsuccessful</h3>
                    <p>{this.state.error}</p>
                    <button className="btn btn-light" onClick={this.backToForm}>Back to Enrolment</button>
                </div>
                <div className="account-success">
                    {/* <div className="c-img">
                        <Suspense fallback={null}>
                            <ImageLoader type="image" src={TICK_CIRCLE_BIG} />
                        </Suspense>
                    </div> */}
                    {/* <h3>Your account has been created<br />successfully!</h3> */}
                    {/* <p>You will receive an email confirmation link informing you that your account has been successfully created.</p> */}
                    {/* <a href={COMPANY_MICRO_SITE} className="btn btn-light">Go to Home</a> */}
                </div>
            </div>
        )
    }
}

export default AdoptError;